module.exports = __webpack_public_path__ + "static/img/1.ffd6013.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/1.png
// module id = hjBp
// module chunks = 0